import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-video-uploaded',
  templateUrl: './video-uploaded.component.html',
  styleUrls: ['./video-uploaded.component.scss']
})
export class VideoUploadedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() public type;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
